import React, { Component, Fragment } from 'react';
import Grid from '@mui/material/Grid';
import GroupIcon from '@mui/icons-material/Group';

class ShowRoleTendantList extends Component {

    render () {  
        const auth = this.props.auth
        const tendant = this.props.tendants
        
        return (
            <Fragment>
                <ul className="nobullet">
              {auth.map(authdata => {
                  //console.log(authdata)
                  let tendantname = tendant.map(tendantdata => {
                      if (tendantdata.id === authdata.accountId){
                          return tendantdata.name
                      }
                  })
                 return (<li key={authdata.id}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={1}><GroupIcon /> </Grid>
                                <Grid item xs={12} sm={5}>{authdata.role.name} </Grid> 
                                <Grid item xs={12} sm={6}>{tendantname} </Grid> 
                            </Grid> 
                        </li>
                                )
                            
               })
              }
              </ul>
            </Fragment>
        )
    }
}







export default ShowRoleTendantList;